import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import IcpInspectionStatusChip from "../../styled/IcpInspectionStatusChip";
import ICPNumberChip from "../../styled/ICPNumberChip";
import WorkOrderDate from "../../styled/WorkOrderDate";

export default function IcpInspectionSummaryGrid({workOrderId, icpNumber, workOrderDetails}) {

    return (

        <Grid container>
            <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>{workOrderDetails?.workOrder?.workType}</strong></Typography>
                <Typography variant="body1" paragraph>Work Order: <strong>{workOrderId}</strong></Typography>
                <Typography variant="body1">Premise Type: <strong>{workOrderDetails?.workOrder?.premiseType}</strong></Typography>
                <Typography variant="body1">Approved Contractor: <strong>{workOrderDetails?.workOrder?.networkApprovedContractor?.name}</strong></Typography>
                <Typography variant="body1">Retailer: <strong>{workOrderDetails?.workOrder?.retailerName}</strong></Typography>
                <Typography variant="body1">
                    <WorkOrderDate prefix='Scheduled: ' isoDateString={workOrderDetails?.workOrder?.scheduledDate} boldDate={true} />
                </Typography>
                <Typography variant="body1">
                    <WorkOrderDate prefix='Connected: ' isoDateString={workOrderDetails?.workOrder?.connectionDate} boldDate={true} />
                </Typography>

                <Typography sx={{my:1}} variant="body1"><strong>{workOrderDetails?.workOrder?.description}</strong></Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography variant="body1" sx={{my:1}} paragraph>
                    <ICPNumberChip icpNumber={icpNumber} />
                </Typography>
                <Box>
                    <IcpInspectionStatusChip sx={{my:1}} status={workOrderDetails?.workOrder?.status} onHoldReason={workOrderDetails?.workOrder?.onHoldReason} />
                </Box>
            </Grid>
            {/* <DebugBox title="workOrderDetails" stringify>{workOrderDetails?.workOrder}</DebugBox> */}
        </Grid>

    )
}